import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import Modal from '@material-ui/core/Modal';
import Button from "@material-ui/core/Button";
import Grow from '@material-ui/core/Grow';
import modalStyle from './style'

const styles = theme => (Object.assign({}, modalStyle, {
	modalBody: {
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
	},
	buttonContainer:{
		display: 'flex',
		justifyContent: "space-between",

	},
	button:{
		display: 'block',
		marginTop: '20px'
	}
}));


function ConfirmModal(props) {
	const { classes,
		modal,
		onConfirm,
		onCancel } = props;

	return (
		<Modal
			className={classes.modal}
			open={true}
		>
			<Grow in={true}>
				<div className={`${classes.modalBody} ${classes.defaultBody}`}>
					{modal.bodyText}
					<div className={classes.buttonContainer}>
						<Button
							variant="contained"
							className={`${classes.button}`}
							onClick={() => {onCancel()}}
						>
							{modal.cancelButtonText}
						</Button>
						<Button
							variant="contained"
							className={`${classes.button}`}
							onClick={() => {onConfirm()}}
						>
							{modal.confirmButtonText}
						</Button>
					</div>
				</div>
			</Grow>

		</Modal>
	)
}

ConfirmModal.propTypes = {
	classes: PropTypes.shape({
		modal: PropTypes.string.isRequired,
		modalBody: PropTypes.string.isRequired,
		button: PropTypes.string.isRequired,
	}).isRequired,

	onConfirm: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
};


export default withStyles(styles)(ConfirmModal);
